export default function createElement(type, properties, text) {
  const element = document.createElement(type);
  let value = '';
  if (properties) {
    // eslint-disable-next-line
    for (const key in properties) {
      value = properties[key];
      // If is an array, join the items with space
      element.setAttribute(key, Array.isArray(value) ? value.join(' ') : value);
    }
  }
  if (text) {
    element.innerHTML = text;
  }
  return element;
}
